function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m452.34 284.762-38.012-15.997v140.87l38.012-15.997c10.421-4.386 17.198-14.59 17.198-25.896v-57.082c0-11.308-6.777-21.513-17.198-25.898z",
  fill: "#e7889d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m445.233 281.771-30.905-13.007v140.87l30.905-13.007z",
  fill: "#e16e7e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m353.326 512h-267.16c-17.016 0-30.811-13.794-30.811-30.811v-410.396c0-17.016 13.794-30.811 30.811-30.811h267.16c33.69 0 61.001 27.311 61.001 61.002v350.015c.001 33.69-27.311 61.001-61.001 61.001z",
  fill: "#88d37f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m86.166 39.982c-17.016 0-30.811 13.795-30.811 30.811v410.396c.001 17.017 13.795 30.811 30.811 30.811h176.942c-144.321-81.482-128.888-328.027-128.582-472.018z",
  fill: "#5ec682"
}), /*#__PURE__*/React.createElement("path", {
  d: "m353.326 39.982h-100.736v149.067c0 34.544 28.104 62.649 62.649 62.649h99.089v-150.714c0-33.69-27.312-61.002-61.002-61.002z",
  fill: "#5ec682"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m302.133 338.69h-134.583c-4.142 0-7.5-3.358-7.5-7.5 0-4.143 3.358-7.5 7.5-7.5h134.583c4.142 0 7.5 3.357 7.5 7.5 0 4.142-3.358 7.5-7.5 7.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271.105 398.755h-72.528c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h72.528c4.142 0 7.5 3.357 7.5 7.5 0 4.142-3.357 7.5-7.5 7.5z"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.842,
  cy: 196.845,
  fill: "#cde9fa",
  rx: 59.944,
  ry: 59.944,
  transform: "matrix(.707 -.707 .707 .707 -70.407 223.713)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.842,
  cy: 196.845,
  fill: "#cde9fa",
  rx: 59.944,
  ry: 59.944,
  transform: "matrix(.707 -.707 .707 .707 -70.407 223.713)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m252.59 139.574v49.476c0 20.366 9.774 38.487 24.872 49.937 10.708-10.828 17.324-25.711 17.324-42.142-.001-26.927-17.755-49.705-42.196-57.271z",
  fill: "#a2ddfd"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#59636f"
}, /*#__PURE__*/React.createElement("path", {
  d: "m76.463 83.86h-42.214c-14.656 0-26.537 11.881-26.537 26.537 0 14.656 11.881 26.537 26.537 26.537h42.214c14.656 0 26.537-11.881 26.537-26.537-.001-14.656-11.882-26.537-26.537-26.537z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.463 194.256h-42.214c-14.656 0-26.537 11.881-26.537 26.537 0 14.656 11.881 26.537 26.537 26.537h42.214c14.656 0 26.537-11.881 26.537-26.537-.001-14.656-11.882-26.537-26.537-26.537z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.463 304.653h-42.214c-14.656 0-26.537 11.881-26.537 26.537 0 14.656 11.881 26.537 26.537 26.537h42.214c14.656 0 26.537-11.881 26.537-26.537-.001-14.656-11.882-26.537-26.537-26.537z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.463 415.049h-42.214c-14.656 0-26.537 11.881-26.537 26.537 0 14.656 11.881 26.537 26.537 26.537h42.214c14.656 0 26.537-11.881 26.537-26.537-.001-14.656-11.882-26.537-26.537-26.537z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m472.544 0h-157.305c-17.532 0-31.744 14.212-31.744 31.744v157.306c0 17.531 14.212 31.744 31.744 31.744h11.331c0-37.181 30.141-67.322 67.322-67.322s67.321 30.141 67.321 67.322h11.331c17.532 0 31.744-14.212 31.744-31.744v-157.306c0-17.532-14.212-31.744-31.744-31.744z",
  fill: "#fbf1cf"
}), /*#__PURE__*/React.createElement("path", {
  d: "m346.53 172.959c-22.315-61.791-20.249-148.203-16.396-172.959h-14.895c-17.532 0-31.744 14.212-31.744 31.744v157.306c0 17.531 14.212 31.744 31.744 31.744h11.331c0-18.711 7.638-35.634 19.96-47.835z",
  fill: "#fae0bd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m461.213 220.793c0-37.181-30.141-67.322-67.321-67.322s-67.322 30.141-67.322 67.322z",
  fill: "#7acefa"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 393.892,
  cy: 116.113,
  fill: "#a2ddfd",
  r: 48.654
}));

var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.39e7966c.svg";
export { ForwardRef as ReactComponent };